var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 12.75C13.4406 12.75 14.0002 12.1903 14.0002 11.5C14.0002 10.8096 13.4406 10.25 12.7502 10.25C12.0599 10.25 11.5002 10.8096 11.5002 11.5C11.5002 12.1903 12.0599 12.75 12.7502 12.75Z",
    fill: "#0036B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75024 7C6.75024 4.79087 8.5411 3 10.7502 3H15.2502C17.4594 3 19.2502 4.79087 19.2502 7H21.7502C22.8548 7 23.7502 7.89543 23.7502 9V12.4793C23.7506 12.4938 23.7506 12.5083 23.7502 12.5227V19C23.7502 20.1046 22.8548 21 21.7502 21H3.75024C2.64567 21 1.75024 20.1046 1.75024 19V12.5227C1.74992 12.5083 1.74992 12.4938 1.75024 12.4793V9C1.75024 7.89543 2.64567 7 3.75024 7H6.75024ZM8.75024 7C8.75024 5.89543 9.64567 5 10.7502 5H15.2502C16.3548 5 17.2502 5.89543 17.2502 7H8.75024ZM3.75024 19V13.781L12.5077 15.9704C12.6669 16.0102 12.8335 16.0102 12.9928 15.9704L21.7502 13.781V19H3.75024ZM12.7502 13.9695L3.75024 11.7195V9H21.7502V11.7195L12.7502 13.9695Z",
    fill: "#0036B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/handbag.86fd0cd4.svg";
export { ForwardRef as ReactComponent };